import * as React from 'react';
import styled from 'styled-components';
import { Spinner } from '../Spinner';

const LoadingWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1000;
    background-color: rgba(255, 255, 255, 0.6);
    border-radius: 4px;
`;

const Loadable: React.FC<{ isLoading: boolean }> = ({ isLoading, children }) => {
    if (isLoading) {
        return (
            <>
                {children}
                <LoadingWrapper>
                    <Spinner size="md" />
                </LoadingWrapper>
            </>
        );
    }

    return <>{children}</>;
};

export default Loadable;
